import React from 'react'
import { connect } from 'react-redux'
import Loading from './widgets/Loading'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import {
    PRODUCT_UPDATE_PAGE_LOADED,
    PRODUCT_UPDATE_PAGE_UNLOADED,
    PRODUCT_UPDATE,
    PRODUCT_DELETE,
    REDIRECT,
} from '../constants/actionTypes'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import { BASE_COIN_SYMBOL } from '../constants/config'
import ListErrors from './ListErrors'
const Promise = global.Promise
const mapStateToProps = state => ({
    ...state.settings,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
    baseAccount: state.common.baseAccount,
})

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: PRODUCT_UPDATE_PAGE_LOADED, payload }),
    onSubmit: (payload) => {
        dispatch({ type: PRODUCT_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: PRODUCT_UPDATE_PAGE_UNLOADED }),
    onDelete: (payload) =>
        dispatch({ type: PRODUCT_DELETE, payload }),
    onRedirect: () =>
        dispatch({ type: REDIRECT }),
})

class ProductEdit extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            price: '',
            currency: '',
            category: '',
            categories: []
        }
        this.onSelectCategory = this.onSelectCategory.bind(this)
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (name, price, currency, category) => ev => {
            ev.preventDefault();
            const payload = agent.Products.updateProduct(this.props.match.params.key, name, price, currency, category)
            this.props.onSubmit(payload);
        }
        this.delete = () => ev => {
            ev.preventDefault()
            const payload = agent.Products.deleteProduct(this.props.match.params.key)
            this.props.onDelete(payload)
        }
    }
    onSelectCategory(option) {
        this.setState({ category: option.value })
    }
    componentWillMount() {
        if (this.props.currentUser) {
            this.setState({ currency: this.props.currentUser.currency_code })
            const payload = Promise.all([
                agent.Products.getDetail(this.props.match.params.key),
                agent.Categories.getCategories(this.props.currentUser.key)
            ])
            this.props.onLoad(payload);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.updated === true) {
            store.dispatch(push('/products/manage'))
            this.props.onRedirect()
        } else if (nextProps.product) {
            Object.assign(this.state, {
                name: nextProps.product.name,
                price: nextProps.product.price,
                currency: nextProps.product.currency,
                category: nextProps.product.category_name,
            })
            let categories = []
            for (let i in nextProps.categories) {
                let name = nextProps.categories[i].name
                categories.push({ label: name, value: name })
            }
            this.setState({ categories: categories })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.product) {
            return (
                <Loading />
            )
        }
        const name = this.state.name;
        const price = this.state.price;
        const currency = this.state.currency
        const category = this.state.category
        const categories = this.state.categories
        return (
            <div>
                <Header />
                <CrumbBox data={[{ key: 'Update Product' }]} rootKey='/settings' rootVal='Settings' />
                <div id="focus">
                    <div id="main">
                        <div id="main-wrap">
                            <div id="focus-wrap">
                                <h2>Update Product</h2>
                                <div className="FormItem">
                                    <label>Name</label>
                                    <input type="text" placeholder="Product Name" value={name} onChange={this.updateState('name')} />
                                </div>
                                <div className="FormItem">
                                    <label>Category</label>
                                    <div style={{ maxWidth: '500px', 'text-align': 'left' }}><Dropdown options={categories} onChange={this.onSelectCategory} value={category} /></div>
                                </div>
                                <div className="FormItem">
                                    <label>Price</label>
                                    <input
                                        type="text"
                                        placeholder="Price"
                                        value={price}
                                        onChange={this.updateState('price')} />
                                </div>
                                <div className="FormItem">
                                    <label>Currency</label>
                                    <span className="ReferenceInput">{currency}</span>
                                </div>
                                <ListErrors errors={this.props.errors} />
                                <div className="FormItem">
                                    <button type="button"
                                        onClick={this.submitForm(name, price, currency, category)}
                                        disabled={this.props.inProgress}>
                                        Update Product
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.delete()}
                                        disabled={this.props.inProgress}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductEdit)
